import { styled } from '@mui/material';
import { Maybe } from '@/common/types';
import { factoryCategoryColorMap, tremorIndexColorMap } from '../const';
import { FactorCategory } from '../types/FactorCategory.enum';

export const OutcomeSliderWrapper = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(8),
}));

export const OutcomeSliderFactors = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    margin: '0 auto',
    maxWidth: 502,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    gap: 0,
}));

export const OutcomeSliderSlot = styled('div')<{
    $factorCategory: FactorCategory;
    $isActive: boolean;
}>(({ theme, $factorCategory, $isActive }) => ({
    background: 'none',
    padding: theme.spacing(0.5),
    flexGrow: 1,
    alignSelf: 'stretch',
    visibility: $isActive ? 'visible' : 'hidden',
    textAlign: 'center',
    fontSize: 20,

    '> svg': {
        color: factoryCategoryColorMap[$factorCategory],
    },
}));

export const OutcomeSliderFactor = styled('div')<{ $factorCategory: FactorCategory; $tremorIndex: Maybe<number> }>(
    ({ theme, $factorCategory, $tremorIndex }) => ({
        border: '1px solid #B0B0B0',
        background:
            $tremorIndex !== undefined ? tremorIndexColorMap[$tremorIndex] : factoryCategoryColorMap[$factorCategory],
        padding: theme.spacing(1.5),
        flexGrow: 1,
        alignSelf: 'stretch',
    }),
);

export const OutcomeSliderFactorDescription = styled('div')<{ $factorCount: number }>(({ theme, $factorCount }) => ({
    color: '#B0B0B0',
    padding: theme.spacing(1.5),
    width: `calc(100%/${$factorCount})`,
    flexGrow: 1,
    alignSelf: 'stretch',
    border: '1px solid #B0B0B0',
    borderTop: 'none',
    borderRightWidth: 0.5,
    borderLeftWidth: 0.5,

    '&:first-child': {
        borderLeftWidth: 1,
    },
    '&:last-child': {
        borderRightWidth: 1,
    },
}));
